<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        {{ initialData?.title?.trim() ? 'Edit Success Page' : 'Create Success Page' }}
      </h2>
      <button type="button" class="close-button" (click)="onClose()" aria-label="Close">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="form-section">
        <div class="form-group-block">
          <h3 class="group-title">Brand</h3>
          <div class="toggle-row">
            <span>Reuse from landing page</span>
            <label class="toggle-switch" [class.on]="formData.reuseLandingBrand">
              <input
                type="checkbox"
                class="toggle-switch-input"
                [(ngModel)]="formData.reuseLandingBrand"
                (ngModelChange)="onReuseLandingBrandChange()"
                aria-label="Reuse from landing page"
              />
              <span class="toggle-switch-track" aria-hidden="true">
                <span class="toggle-switch-knob"></span>
              </span>
            </label>
          </div>
          <ng-container *ngIf="!formData.reuseLandingBrand">
            <label class="form-label">Logo<span class="required">*</span></label>
            <div
              class="file-upload-container"
              [class.error]="validationErrors.logo || fileValidationError"
            >
              <div class="file-upload-area" *ngIf="!logoFile && !formData.logoUrl">
                <input
                  type="file"
                  id="success-logo-upload"
                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                  class="file-input"
                  (change)="onLogoUpload($event)"
                />
                <label class="file-upload-label" for="success-logo-upload">
                  <div class="upload-icon">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M8 1V11M8 11L5 8M8 11L11 8M3 13H13"
                        stroke="#64748B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <span class="upload-text"
                    >Drag &amp; drop your files here or <strong>browse</strong> to upload</span
                  >
                  <span class="upload-info"
                    >.png, .jpg, .jpeg Max file size - 2MB, Max dimensions -
                    {{ maxLogoDimensions.width }}x{{ maxLogoDimensions.height }}px</span
                  >
                </label>
              </div>

              <div class="file-uploaded" *ngIf="logoFile || formData.logoUrl">
                <div class="uploaded-file">
                  <div class="success-icon" *ngIf="!isUploadingLogo">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <circle cx="8" cy="8" r="6" fill="#079271" />
                      <path
                        d="M5.5 8L7 9.5L10.5 6"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="loading-spinner-icon" *ngIf="isUploadingLogo">
                    <div class="spinner"></div>
                  </div>
                  <span class="file-name">{{ logoFile?.name || logoFileName }}</span>
                  <button
                    type="button"
                    class="remove-file"
                    (click)="removeLogo()"
                    [disabled]="isUploadingLogo"
                    aria-label="Remove logo"
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M9 3L3 9M3 3L9 9"
                        stroke="#A7ABB3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="error-message" *ngIf="validationErrors.logo">
              {{ validationErrors.logo }}
            </div>
            <div class="error-message" *ngIf="fileValidationError">{{ fileValidationError }}</div>
          </ng-container>
          <p class="reuse-logo-hint" *ngIf="formData.reuseLandingBrand">
            Logo will be reused from the landing page.
          </p>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Message</h3>
          <label class="form-label" for="success-title">Title<span class="required">*</span></label>
          <input
            id="success-title"
            class="form-input"
            [class.error]="validationErrors.title"
            [(ngModel)]="formData.title"
            (input)="onTitleChange()"
          />
          <div class="error-message" *ngIf="validationErrors.title">
            {{ validationErrors.title }}
          </div>
          <label class="form-label" for="success-body">Body<span class="required">*</span></label>
          <div class="input-with-tags">
            <textarea
              id="success-body"
              class="form-input form-textarea"
              [class.error]="validationErrors.body"
              [(ngModel)]="formData.body"
              (input)="onBodyChange()"
            ></textarea>
            <div class="tags-container">
              <span
                class="tag"
                *ngFor="let tag of availableBodyTags; trackBy: trackByIndex"
                (click)="insertBodyTag(tag)"
              >
                {{ tag }}
              </span>
            </div>
          </div>
          <div class="error-message" *ngIf="validationErrors.body">{{ validationErrors.body }}</div>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">CTA</h3>
          <div class="toggle-row">
            <span>Show CTA</span>
            <label class="toggle-switch" [class.on]="formData.showCta">
              <input
                type="checkbox"
                class="toggle-switch-input"
                [(ngModel)]="formData.showCta"
                aria-label="Show CTA"
              />
              <span class="toggle-switch-track" aria-hidden="true">
                <span class="toggle-switch-knob"></span>
              </span>
            </label>
          </div>
          <ng-container *ngIf="formData.showCta">
            <label class="form-label" for="success-cta-label"
              >Label<span class="required">*</span></label
            >
            <input
              id="success-cta-label"
              class="form-input"
              [class.error]="validationErrors.ctaText"
              [(ngModel)]="formData.ctaText"
              maxlength="30"
              (input)="onCtaTextChange()"
            />
            <div class="error-message" *ngIf="validationErrors.ctaText">
              {{ validationErrors.ctaText }}
            </div>
            <label class="form-label" for="success-cta-url"
              >URL<span class="required">*</span></label
            >
            <input
              id="success-cta-url"
              class="form-input"
              [class.error]="validationErrors.ctaUrl"
              [(ngModel)]="formData.ctaUrl"
              (input)="onCtaUrlChange()"
            />
            <div class="error-message" *ngIf="validationErrors.ctaUrl">
              {{ validationErrors.ctaUrl }}
            </div>
            <p class="form-label button-color-label">Button Color<span class="required">*</span></p>
            <div class="color-grid">
              <button
                *ngFor="let color of buttonColors; trackBy: trackByIndex"
                type="button"
                class="color-dot"
                [style.backgroundColor]="color"
                [class.selected]="formData.ctaColor === color"
                [attr.aria-label]="'Select color ' + color"
                (click)="onColorSelect(color)"
              ></button>
            </div>
          </ng-container>
        </div>

        <div class="form-group-block">
          <h3 class="group-title">Resend</h3>
          <div class="toggle-row">
            <span>Show resend button</span>
            <label class="toggle-switch" [class.on]="formData.showResend">
              <input
                type="checkbox"
                class="toggle-switch-input"
                [(ngModel)]="formData.showResend"
                aria-label="Show resend button"
              />
              <span class="toggle-switch-track" aria-hidden="true">
                <span class="toggle-switch-knob"></span>
              </span>
            </label>
          </div>
          <ng-container *ngIf="formData.showResend">
            <label class="form-label" for="success-max-attempts">Max attempts</label>
            <input
              id="success-max-attempts"
              type="number"
              min="1"
              max="10"
              class="form-input"
              [class.error]="validationErrors.maxAttempts"
              [(ngModel)]="formData.maxAttempts"
              (input)="onMaxAttemptsChange()"
            />
            <div class="error-message" *ngIf="validationErrors.maxAttempts">
              {{ validationErrors.maxAttempts }}
            </div>
            <label class="form-label" for="success-cooldown">Cooldown text</label>
            <input id="success-cooldown" class="form-input" [(ngModel)]="formData.cooldownText" />
          </ng-container>
        </div>
      </div>

      <div class="preview-section">
        <div class="preview-toolbar">
          <div class="preview-toggle" role="group" aria-label="Preview mode toggle">
            <button
              type="button"
              class="preview-toggle-btn"
              [class.active]="previewMode === 'desktop'"
              (click)="setPreviewMode('desktop')"
              aria-label="Desktop preview"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 13H11.75M5.75 10V13M10.25 10V13M1.25 1.75C1.25 1.55109 1.32902 1.36032 1.46967 1.21967C1.61032 1.07902 1.80109 1 2 1H14C14.1989 1 14.3897 1.07902 14.5303 1.21967C14.671 1.36032 14.75 1.55109 14.75 1.75V9.25C14.75 9.44891 14.671 9.63968 14.5303 9.78033C14.3897 9.92098 14.1989 10 14 10H2C1.80109 10 1.61032 9.92098 1.46967 9.78033C1.32902 9.63968 1.25 9.44891 1.25 9.25V1.75Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              type="button"
              class="preview-toggle-btn"
              [class.active]="previewMode === 'mobile'"
              (click)="setPreviewMode('mobile')"
              aria-label="Mobile preview"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 2H6.75M6 11.75V11.7575M1.5 2.75C1.5 2.35218 1.65804 1.97064 1.93934 1.68934C2.22064 1.40804 2.60218 1.25 3 1.25H9C9.39782 1.25 9.77936 1.40804 10.0607 1.68934C10.342 1.97064 10.5 2.35218 10.5 2.75V13.25C10.5 13.6478 10.342 14.0294 10.0607 14.3107C9.77936 14.592 9.39782 14.75 9 14.75H3C2.60218 14.75 2.22064 14.592 1.93934 14.3107C1.65804 14.0294 1.5 13.6478 1.5 13.25V2.75Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="preview-card" [class.mobile-preview]="previewMode === 'mobile'">
          <div class="preview-card-top">
            <button type="button" class="view-link" (click)="onViewInBrowser()">
              View in browser →
            </button>
          </div>
          <div class="preview-logo" [class.has-image]="!!logoPreviewUrl">
            <img *ngIf="logoPreviewUrl" [src]="logoPreviewUrl" alt="Logo preview" />
            <span *ngIf="!logoPreviewUrl">Logo</span>
          </div>
          <h4 class="preview-title">{{ getPreviewTitle() }}</h4>
          <p class="preview-body">{{ getPreviewBody() }}</p>
          <button
            *ngIf="formData.showCta"
            type="button"
            class="preview-cta-button"
            [style.backgroundColor]="formData.ctaColor"
          >
            {{ getPreviewCtaText() }}
          </button>
          <div class="preview-resend-footer" *ngIf="formData.showResend">
            <span class="preview-resend-status">{{ getResendStatusText() }}</span>
            <button type="button" class="preview-resend-link">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M2.33333 7C2.33333 4.42267 4.42267 2.33333 7 2.33333C8.41421 2.33333 9.68571 2.905 10.5858 3.805M11.6667 7C11.6667 9.57733 9.57733 11.6667 7 11.6667C5.58579 11.6667 4.31429 11.095 3.41421 10.195M2.33333 2.33333V5.66667H5.66667M8.33333 11.6667V8.33333H11.6667"
                  stroke="currentColor"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Resend
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="onReset()">Reset</button>
      <button type="button" class="btn btn-primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div>
